import { useMemo } from "react";
/**
 * useIsImdbIdValid
 *
 * @description A custom hook that checks if the provided IMDb ID is valid.
 * @param {string} IMDbId - The IMDb ID to validate.
 * @returns {boolean} - Returns true if the IMDb ID is valid, false otherwise.
 *
 */
const useIsImdbIdValid = (IMDbId) => useMemo(() => Boolean(IMDbId && /^tt\d+$/u.test(IMDbId)), [IMDbId]);
export default useIsImdbIdValid;
